import React from 'react';
import Header from './Header'; // Pfad zu deinem Header anpassen
import Footer from './Footer'; // Pfad zu deinem Footer anpassen
import './Impressum.css';

const Impressum: React.FC = () => {
    return (
        <div className="impressum-page-wrapper">
            {/* Dein globaler Header */}
            {/* Hauptinhalt des Impressums */}
            <main className="impressum-content-container">
                <header className="impressum-header">
                    <h2>IMPRESSUM</h2>
                    <div className="divider-wrapper">
                        <hr className="signature-line" />
                    </div>
                </header>

                <div className="impressum-body">
                    <section className="legal-section">
                        <h2>Angaben gemäß § 5 DDG</h2>
                        <p>
                            Sayme Akaltin
                            handelnd unter: Lilith Brunch & Wine Bar
                            Fasanenstraße 42<br/>
                            10719 Berlin
                            Deutschland
                            Inhaberin:
                            Sayme Akaltin
                        </p>
                    </section>

                    <section className="legal-section">
                        <h2>Kontakt</h2>
                        <p>
                            Telefon: 030 26366727<br />
                            E-Mail: info@lilithberlin.de
                        </p>
                    </section>
                    <section className="legal-section">
                        <h2>Umsatzsteuer-ID</h2>
                        <p>
                            Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br/>
                            DE 987 654 321
                        </p>
                        <h2 id={'more'}>MORE COMING SOON!</h2>
                    </section>


                    {/*<section className="legal-section">*/}
                    {/*    <h2>Redaktionell verantwortlich</h2>*/}
                    {/*    <p>*/}
                    {/*        Max Mustermann<br />*/}
                    {/*        Musterstraße 123<br />*/}
                    {/*        12345 Musterstadt*/}
                    {/*    </p>*/}
                    {/*</section>*/}
                </div>
            </main>
        </div>
    );
};

export default Impressum;